export const INSPIRATIONS_RESULTS_GRID_CLASS =
    'row -without-padding gap-grid';
